import React from "react";
import "./footer.scss";
import { useSendFormMutation } from "../../redux/services/crmAPI";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setStatus } from "../../redux/slices/statusSlice";
import { usePingQuery } from "../../redux/services/crmAPI";

const Footer = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const userPermission = useSelector((state) => state.status.userPermission);

    const [singOut] = useSendFormMutation();
    const { refetch: refetchPing } = usePingQuery("ping");

    const logOutHandler = async () => {
        await singOut({ body: {}, url: "sign-out" }).unwrap();

        localStorage.setItem("isLoged", JSON.stringify(false));
        dispatch(setStatus(false));

        await refetchPing();

        navigate("/");
    };

    return (
        <footer className="footer">
            © 2023 Склад 7.1.78. Ви увійшли як {userPermission?.name}.<span onClick={logOutHandler}> Вийти</span>
        </footer>
    );
};

export default Footer;
